import {
  GET_BATTLEFIELD,
  GET_BATTLEFIELD_SUCCESS,
  GET_MY_BATTLEFIELD_SUCCESS,
  GET_BATTLEFIELD_FAIL,
  GET_SPEC_BATTLEFIELD,
  GET_SPEC_BATTLEFIELD_SUCCESS,
  GET_SPEC_BATTLEFIELD_FAIL,
  ADD_BATTLEFIELD,
  ADD_BATTLEFIELD_SUCCESS,
  ADD_BATTLEFIELD_FAIL,
  UPDATE_BATTLEFIELD,
  UPDATE_BATTLEFIELD_SUCCESS,
  UPDATE_BATTLEFIELD_FAIL,
  DELETE_BATTLEFIELD,
  DELETE_BATTLEFIELD_SUCCESS,
  DELETE_BATTLEFIELD_FAIL,
  UPDATE_PERIOD,
  UPDATE_PERIOD_SUCCESS,
  UPDATE_PERIOD_FAIL,
  SHOW_LOADING,
  HIDE_LOADING
} from './actionTypes';

// GET ALL BATTLEFIELD ORDERS
export const getBattlefield = (battle) => ({
  type: GET_BATTLEFIELD,
  payload: battle
});
export const getBattlefieldSuccess = (battles) => ({
  type: GET_BATTLEFIELD_SUCCESS,
  payload: battles
});
export const getMyBattlefieldSuccess = (battles) => ({
  type: GET_MY_BATTLEFIELD_SUCCESS,
  payload: battles
});
export const getBattlefieldFail = error => ({
  type: GET_BATTLEFIELD_FAIL,
  payload: error,
});
// GET ALL BATTLEFIELD ORDERS WITHIN GIVEN RANGE
export const getSpecBattlefield = (battle) => ({
  type: GET_SPEC_BATTLEFIELD,
  payload: battle
});
export const getSpecBattlefieldSuccess = (battles) => ({
  type: GET_SPEC_BATTLEFIELD_SUCCESS,
  payload: battles
});
export const getSpecBattlefieldFail = (error) => ({
  type: GET_SPEC_BATTLEFIELD_FAIL,
  payload: error
});
// ADD NEW ORDER TO BATTLEFEILD TABLE
export const addBattlefield = (battle) => ({
  type: ADD_BATTLEFIELD,
  payload: battle
});
export const addBattlefieldSuccess = battle => ({
  type: ADD_BATTLEFIELD_SUCCESS,
  payload: battle,
});
export const addBattlefieldFail = error => ({
  type: ADD_BATTLEFIELD_FAIL,
  payload: error,
});
// UPDATE ORDER INSIDE BATTLEFEILD TABLE
export const updateBattlefield = (battle) => ({
  type: UPDATE_BATTLEFIELD,
  payload: battle
});
export const updateBattlefieldSuccess = battle => ({
  type: UPDATE_BATTLEFIELD_SUCCESS,
  payload: battle,
});
export const updateBattlefieldFail = error => ({
  type: UPDATE_BATTLEFIELD_FAIL,
  payload: error,
});

// DELETE ORDER FROM BATTLEFEILD TABLE
export const deleteBattlefield = (battle) => ({
  type: DELETE_BATTLEFIELD,
  payload: battle
});
export const deleteBattlefieldSuccess = battle => ({
  type: DELETE_BATTLEFIELD_SUCCESS,
  payload: battle,
});
export const deleteBattlefieldFail = error => ({
  type: DELETE_BATTLEFIELD_FAIL,
  payload: error,
});
// UPDATE PERIOD TIME
export const updatePeriod = (period) => ({
  type: UPDATE_PERIOD,
  payload: period
});
export const updatePeriodSuccess = period => ({
  type: UPDATE_PERIOD_SUCCESS,
  payload: period,
})
export const updatePeriodFail = error => ({
  type: UPDATE_PERIOD_FAIL,
  payload: error,
})

export const showLoading = (status) => ({
  type: SHOW_LOADING,
  payload: status
});
export const hideLoading = (status) => ({
  type: HIDE_LOADING,
  payload: status
});